import { useEffect, useState } from 'react';
import { Label, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { Button, FormControl } from 'react-bootstrap';
import Select from 'react-select';
import ReactDatePicker from 'react-datepicker';
import ReactInputMask from 'react-input-mask';
import { format } from 'date-fns';
import ptBR from 'date-fns/locale/pt-BR';
import { toast } from 'react-toastify';
import { Filter, X } from 'react-feather';
import ConfiguracaoUsuariosService from '../../../Services/Configuracao/ConfiguracaoUsuariosService';

const OPCOES_FILTRAR_POR = [
  { value: 'data_abertura', label: 'Data de Abertura' },
  { value: 'data_situacao', label: 'Data da Situação' },
];

const OPCOES_PERIODO = [
  { value: 'dia_atual', label: 'Dia Atual' },
  { value: 'semana_atual', label: 'Semana Atual' },
  { value: 'mes_atual', label: 'Mês Atual' },
  { value: 'ultimos_30_dias', label: 'Últimos 30 Dias' },
  { value: 'trimestre_atual', label: 'Trimestre Atual' },
  { value: 'ano_atual', label: 'Ano Atual' },
  { value: 'personalizado', label: 'Personalizado' },
];

const CAMPOS_PERIODO = [
  'data_abertura',
  'data_abertura_inicio',
  'data_abertura_fim',
  'data_situacao',
  'data_situacao_inicio',
  'data_situacao_fim',
  'situacao_processo',
];

export const getFiltroPeriodoParams = (filtro) =>
  CAMPOS_PERIODO.reduce((params, campo) => {
    if (filtro?.[campo]) params[campo] = filtro[campo];
    return params;
  }, {});

const FiltrarPeriodo = ({ onFiltrar, onLimpar, plugin }) => {
  const [modalAberto, setModalAberto] = useState(false);
  const [filtrarPor, setFiltrarPor] = useState(OPCOES_FILTRAR_POR[0]);
  const [dataAbertura, setDataAbertura] = useState(null);
  const [dataAberturaInicio, setDataAberturaInicio] = useState(null);
  const [dataAberturaFim, setDataAberturaFim] = useState(null);
  const [opcoesSituacao, setOpcoesSituacao] = useState([]);
  const [situacao, setSituacao] = useState(null);
  const [carregandoSituacoes, setCarregandoSituacoes] = useState(false);
  const [filtroAplicado, setFiltroAplicado] = useState(null);
  const [selectKey, setSelectKey] = useState(0);

  const isPorSituacao = filtrarPor?.value === 'data_situacao';
  const isPersonalizado = dataAbertura?.value === 'personalizado';

  useEffect(() => {
    if (!modalAberto || !isPorSituacao || opcoesSituacao.length > 0) return;

    const carregarSituacoes = async () => {
      setCarregandoSituacoes(true);
      try {
        const situacoes = await ConfiguracaoUsuariosService.getProcessoSituacoes();
        const pluginSituacao = plugin[0].toUpperCase() + plugin.substring(1);
        const opcoes = Object.entries(situacoes?.[pluginSituacao] || {}).map(([id, item]) => ({
          value: id,
          label: item,
        }));
        setOpcoesSituacao(opcoes);
      } catch (error) {
        toast.error('Erro ao carregar as situações do processo.');
      } finally {
        setCarregandoSituacoes(false);
      }
    };

    carregarSituacoes();
  }, [modalAberto, isPorSituacao, opcoesSituacao.length, plugin]);

  const handleBuscar = () => {
    if (isPorSituacao && !situacao) {
      toast.warning('Selecione uma situação.');
      return;
    }
    if (!dataAbertura) {
      toast.warning('Selecione um período.');
      return;
    }
    if (isPersonalizado && (!dataAberturaInicio || !dataAberturaFim)) {
      toast.warning('Informe a data de início e a data de fim para o período personalizado.');
      return;
    }

    const periodoLabel = isPersonalizado
      ? `${format(dataAberturaInicio, 'dd/MM/yyyy')} - ${format(dataAberturaFim, 'dd/MM/yyyy')}`
      : dataAbertura.label;
    const inicio = dataAberturaInicio ? format(dataAberturaInicio, 'yyyy-MM-dd') : null;
    const fim = dataAberturaFim ? format(dataAberturaFim, 'yyyy-MM-dd') : null;

    const filtro = isPorSituacao
      ? {
          situacao_processo: situacao.value,
          data_situacao: dataAbertura.value,
          data_situacao_inicio: inicio,
          data_situacao_fim: fim,
          _tipo: 'data_situacao',
          _label: `${situacao.label} - ${periodoLabel}`,
        }
      : {
          data_abertura: dataAbertura.value,
          data_abertura_inicio: inicio,
          data_abertura_fim: fim,
          _tipo: 'data_abertura',
          _label: periodoLabel,
        };

    setFiltroAplicado(filtro);
    onFiltrar(filtro);
    setModalAberto(false);
  };

  const handleLimpar = () => {
    setFiltroAplicado(null);
    setFiltrarPor(OPCOES_FILTRAR_POR[0]);
    setDataAbertura(null);
    setDataAberturaInicio(null);
    setDataAberturaFim(null);
    setSituacao(null);
    setSelectKey((k) => k + 1);
    onLimpar();
  };

  const handleFecharModal = () => {
    setModalAberto(false);
    setFiltrarPor(OPCOES_FILTRAR_POR[0]);
    setDataAbertura(null);
    setDataAberturaInicio(null);
    setDataAberturaFim(null);
    setSituacao(null);
    setSelectKey((k) => k + 1);
  };

  return (
    <>
      <div className='d-flex align-items-center justify-content-between mb-3' style={{ flexWrap: 'wrap', gap: '8px' }}>
        <div>
          {filtroAplicado && (
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <p style={{ fontSize: 15, fontWeight: 400, margin: 0 }}>
                {filtroAplicado._tipo === 'data_situacao' ? 'Situação: ' : 'Data Abertura: '}
              </p>
              <span className='badge bg-success d-flex align-items-center' style={{ fontSize: '12px', gap: '6px' }}>
                {filtroAplicado._label}
                <X
                  size={13}
                  onClick={handleLimpar}
                  style={{ cursor: 'pointer', marginLeft: '2px' }}
                  title='Remover filtro'
                />
              </span>
            </div>
          )}
        </div>
        <Button
          className='btn-primary d-flex align-items-center'
          style={{ gap: '6px' }}
          onClick={() => setModalAberto(true)}
        >
          <Filter size={15} className='m-r-2' /> Filtrar Período
        </Button>
      </div>

      <Modal isOpen={modalAberto} toggle={handleFecharModal} centered>
        <ModalHeader toggle={handleFecharModal}>Filtrar Período</ModalHeader>
        <ModalBody>
          <div key={selectKey}>
            <div className='mb-3'>
              <Label>Filtrar por</Label>
              <Select
                options={OPCOES_FILTRAR_POR}
                placeholder='Selecione'
                value={filtrarPor}
                onChange={(opt) => {
                  setFiltrarPor(opt);
                  setDataAbertura(null);
                  setDataAberturaInicio(null);
                  setDataAberturaFim(null);
                  setSituacao(null);
                }}
              />
            </div>

            {isPorSituacao && (
              <div className='mb-3'>
                <Label>Situação</Label>
                <Select
                  options={opcoesSituacao}
                  placeholder='Selecione'
                  value={situacao}
                  isLoading={carregandoSituacoes}
                  onChange={(opt) => setSituacao(opt)}
                />
              </div>
            )}

            <div className='mb-3'>
              <Label>Período</Label>
              <Select
                options={OPCOES_PERIODO}
                placeholder='Selecione'
                value={dataAbertura}
                onChange={(opt) => {
                  setDataAbertura(opt);
                  setDataAberturaInicio(null);
                  setDataAberturaFim(null);
                }}
              />
            </div>

            {isPersonalizado && (
              <div className='row'>
                <div className='col-6'>
                  <Label>Data Início</Label>
                  <FormControl
                    as={ReactDatePicker}
                    autoComplete='off'
                    selected={dataAberturaInicio}
                    onChange={(date) => setDataAberturaInicio(date)}
                    customInput={
                      <ReactInputMask mask='99/99/9999'>
                        {(inputProps) => <input {...inputProps} className='form-control datetimepicker-input digits' />}
                      </ReactInputMask>
                    }
                    locale={ptBR}
                    dateFormat='dd/MM/yyyy'
                    className='form-control datetimepicker-input digits'
                  />
                </div>
                <div className='col-6'>
                  <Label>Data Fim</Label>
                  <FormControl
                    as={ReactDatePicker}
                    autoComplete='off'
                    selected={dataAberturaFim}
                    onChange={(date) => setDataAberturaFim(date)}
                    customInput={
                      <ReactInputMask mask='99/99/9999'>
                        {(inputProps) => <input {...inputProps} className='form-control datetimepicker-input digits' />}
                      </ReactInputMask>
                    }
                    locale={ptBR}
                    dateFormat='dd/MM/yyyy'
                    className='form-control datetimepicker-input digits'
                  />
                </div>
              </div>
            )}
          </div>
        </ModalBody>
        <ModalFooter>
          <Button className='btn-primary' onClick={handleBuscar}>
            Buscar
          </Button>
          <Button className='btn-light' onClick={handleFecharModal}>
            Cancelar
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default FiltrarPeriodo;
